import { HOME } from "../constants/testIds";
import { TRUST_ITEMS } from "../constants/business";

function Icon({ name, className = "" }) {
  const p = { className, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };
  switch (name) {
    case "shield": return (<svg {...p}><path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>);
    case "upi": return (<svg {...p}><path d="M4 5h16v14H4z"/><path d="M8 9v6M12 9v6M16 9v6"/></svg>);
    case "warranty": return (<svg {...p}><path d="M12 2 4 5v7c0 5 3.5 8 8 10 4.5-2 8-5 8-10V5l-8-3Z"/><path d="M12 10v4M12 16.01v.01"/></svg>);
    case "truck": return (<svg {...p}><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>);
    case "hourglass": return (<svg {...p}><path d="M6 3h12M6 21h12M8 3v3l4 6-4 6v3M16 3v3l-4 6 4 6v3"/></svg>);
    case "return": return (<svg {...p}><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>);
    case "chat": return (<svg {...p}><path d="M21 12c0 4.5-4 8-9 8-1.4 0-2.7-.3-3.9-.8L3 21l1.2-4.4C3.5 15.2 3 13.6 3 12c0-4.5 4-8 9-8s9 3.5 9 8Z"/></svg>);
    default: return null;
  }
}

// [4] Trust strip — 56px, canvas bg, hairline borders.  7 items with | dividers.
// Mobile: horizontal scroll-snap.
export default function TrustStrip() {
  return (
    <section
      data-testid={HOME.trustStrip}
      className="bg-[#0A0A0A] hairline-t hairline-b h-14 flex items-center overflow-hidden"
    >
      <div className="mx-auto max-w-[1440px] w-full px-6 h-full">
        <ul
          aria-label="warranty strip — scroll horizontally for more"
          className="warranty-strip-mobile h-full flex items-center gap-6 md:gap-8 overflow-x-auto md:overflow-visible no-scrollbar snap-x snap-mandatory md:snap-none"
        >
          {TRUST_ITEMS.map((item, i) => (
            <li key={item.label} className="flex items-center gap-4 shrink-0 snap-start">
              <div className="flex items-center gap-2 text-white">
                <Icon name={item.icon} className="w-4 h-4 text-[#FF9F1C]" />
                {item.href ? (
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="font-sans text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.04em] whitespace-nowrap hover:text-[#FF9F1C] transition-colors"
                    data-testid={HOME.trustItem}
                  >
                    {item.label}
                  </a>
                ) : (
                  <span
                    className="font-sans text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.04em] whitespace-nowrap"
                    data-testid={HOME.trustItem}
                  >
                    {item.label}
                  </span>
                )}
              </div>
              {i < TRUST_ITEMS.length - 1 && (
                <span aria-hidden className="text-[#1F1F1F] text-sm hidden md:inline">|</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
